// A new account sent to a page that needs the app (a Secret Santa draw from
// the Secret Santa page, ?next= on /register…) first goes through
// onboarding and the plan picker. The page it was headed for is kept here,
// and the dashboard — where that path ends — takes it there once.
// An invitation to a Secret Santa draw is the exception: the newcomer goes
// straight to it, and meets the onboarding when they open the rest of the app.
const KEY = 'tofbox_after_signup';

export const isSantaInvitePath = (path) => /^\/santa\/(?!reveal\/)[^/?#]+/.test(path || '');

export const rememberAfterSignup = (path) => {
  try { localStorage.setItem(KEY, path); } catch { /* private mode */ }
};

export const takeAfterSignup = () => {
  try {
    const path = localStorage.getItem(KEY);
    localStorage.removeItem(KEY);
    return path && path.startsWith('/') && !path.startsWith('//') ? path : null;
  } catch {
    return null;
  }
};

/** The invitation waiting after a Google signup, if any (left in place:
 *  the invitation page clears it). */
export const pendingInvite = () => {
  try {
    const path = localStorage.getItem(KEY);
    return isSantaInvitePath(path) ? path : null;
  } catch {
    return null;
  }
};

export const clearPendingInvite = () => {
  if (pendingInvite()) {
    try { localStorage.removeItem(KEY); } catch { /* private mode */ }
  }
};
